import React from 'react';
import { Button } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import SvgIcon from '../SvgIcon';
import { TooltipRenderProps } from 'react-joyride';

const bem = bemBlock('joyride-tooltip');

interface IJoyrideTooltipProps extends TooltipRenderProps {
  showSkipButton: boolean;
}

function JoyrideTooltip({
  continuous,
  index,
  step,
  skipProps,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
  showSkipButton,
  isLastStep,
}: IJoyrideTooltipProps) {
  const isFirstStep = index === 0;

  return (
    <div className={bem()} {...tooltipProps}>
      {step.title && <span className={bem('title')}>{step.title}</span>}
      <p className={bem('content')}>{step.content}</p>

      <div className={bem('actions')}>
        <div>
          {showSkipButton && (
            <Button size="sm" circle variant="default-light" className={bem('btn-skip')} {...skipProps}>
              <SvgIcon name="X" />
            </Button>
          )}
        </div>

        <div className={bem('actions-right')}>
          {index > 0 && (
            <Button circle variant="white" className={bem('btn-back')} {...backProps}>
              <SvgIcon name="ChevronLeft" />
            </Button>
          )}
          {!isLastStep && continuous && (
            <Button circle variant="white" className={bem('btn-next')} {...primaryProps}>
              <SvgIcon name="ChevronRight" />
            </Button>
          )}
          {!isLastStep && !continuous && (
            <Button circle variant="white" className={bem('btn-close', [{ flashing: isFirstStep }])} {...closeProps}>
              <SvgIcon name="ChevronRight" />
            </Button>
          )}
          {isLastStep && (
            <Button circle variant="primary" {...closeProps}>
              <SvgIcon name="Check" className={bem('check-icon')} />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default React.memo(JoyrideTooltip, (prevProps, nextProps) => prevProps.index === nextProps.index);
